import moment from 'moment';
import { Attr, HasOne, Model } from 'spraypaint';
import { Airline, BusTrip } from './';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class Flight extends ApplicationRecord {
  static jsonapiType = 'flights';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Airline',
        value: 'airline.name',
      },
      {
        text: 'Flight Number',
        value: 'flightNumber',
      },
      {
        text: 'Timetable',
        value: 'service',
      },
      {
        text: 'Arrival/Departure',
        value: 'departure',
        align: 'center',
        width: 160,
      },
      {
        text: 'Time',
        value: 'time',
      },
      {
        text: 'Bus Trip',
        value: 'busTrip',
      },
    ];
  }

  static scopeFactory() {
    return Flight.includes(['airline', 'busTrip']);
  }

  @Attr() flightNumber: string;
  @Attr() service: string;
  @Attr() departure: boolean;
  @Attr() time: string;

  @HasOne() airline: Airline;
  @HasOne() busTrip: BusTrip | null;

  get formattedTime() {
    if (!this.time) {
      return;
    }
    return moment(this.time, 'HH:mm:ss').format('h:mm a');
  }

  get formattedService() {
    if (!this.service) {
      return;
    }

    return this.service.charAt(0).toUpperCase() + this.service.slice(1);
  }

  get flightLabel() {
    if (!this.time) {
      return this.flightNumber;
    }
    return `${this.flightNumber} (${this.formattedTime})`;
  }
}
